import { isB2CPage } from '../utils/page.js';

export const MAX_PRODUCT_DELTA_QTY = 99999;

export const MY_PRODUCTS_REST_URL = `${window.vProductionUrl}/${isB2CPage() ? 'home/' : ''}product/my-products`;

export const MY_PRODUCTS_LINK = `${window.vProductionUrl}/${isB2CPage() ? 'home/' : ''}product-cart`;

export const SUBSTITUTIONS_API_URL = `${window.vProductionUrl}/product/ajax/model/com/schneider/rest/cached/GetSubstitutionsDetailsActor/substitutions`;

export const HMC_API_URL = `${window.vProductionUrl}/product/cache/model/com/schneider/hmc/rest/v2/HMCServiceActor/questionnaires?categoryId=`;

export const HMC_PRESENTATION_URL = `${window.vProductionUrl}/product/cache/model/com/schneider/rest/RangePresentationsActor/presentations?ranges=`;

export const PRODUCT_RESULTS_LIST_URL = `${window.vProductionUrl}/${isB2CPage() ? 'home/' : ''}product-results-list`;

export const LISTING_FILTERS_URL = `${window.vProductionUrl}/home/product-listing-refinements`;

export const RANGE_FILTERS_URL = `${window.vProductionUrl}/product-range-refinements`;

export const COMPARATOR_URL = `/product-comparator`;

export const SITE_INFO_URL = `${window.vProductionUrl}/product/api/site/current`;

export const RESPONSE_STATUS = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING'
};

export const HTTP_STATUS_CODE = {
  serverError: 500,
  serverBusy: 503,
  badRequest: 400,
  notFound: 404
};

// TODO: Migrate to pesDesktopToTablet and pesTabletToDesktop: use utils/match-media constants
export const EVENT_ORIENTATION_TO_MOBILE = 'desktopToMobile';
export const EVENT_ORIENTATION_TO_DESKTOP = 'mobileToDesktop';

export const BREAKPOINTS = {
  tablet: 720,
  desktop: 980,
  wideDesktop: 1200
};

export const KEY_CODE = {
  escape: 27,
  enter: 13,
  backspace: 8,
  up: 38,
  down: 40
};

/** @type { { [siteType: string]: 'b2b' | 'b2c' } } */
export const SITE_TYPE = {
  b2b: 'b2b',
  b2c: 'b2c'
};

// URL Search params

export const OPEN_BUY_ONLINE_SEARCH_PARAM = 'openBuyOnline';

export const REGEXP_NUMBERS_AT_BEGINNING = /^\d+/;
